import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Kai Faust
 * id FE2B1AE3-7158-473B-B1EE-45FB9CAE1137
 * name file-tree
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-tree.svg
 * tags
 * - Files / Folders 
 */
export const FileTreeIcon = createSvgIcon(<><path d="M3,3H9V7H3V3M15,10H21V14H15V10M15,17H21V21H15V17M13,13H7V18H13V20H7L5,20V9H7V11H13V13Z" /></>, 'FileTreeIcon');
export default FileTreeIcon